import type { JiraCustomBackgroundBrightness } from '@atlassian/jira-relay/src/__generated__/ThemeSetterBackground.graphql';

export function getAdjustedColor({
	dominantColor,
	bgImageBrightness,
	isDarkMode,
}: {
	dominantColor: string;
	bgImageBrightness: JiraCustomBackgroundBrightness;
	isDarkMode: boolean;
}) {
	const isLowBrightnessImage = bgImageBrightness === 'DARK';
	let adjustment: number;
	let mixColor: string;

	if (isDarkMode) {
		adjustment = isLowBrightnessImage ? 20 : 70;
		mixColor = '#000000';
	} else {
		adjustment = isLowBrightnessImage ? 70 : 50;
		mixColor = '#FFFFFF';
	}

	return `color-mix(in srgb, ${dominantColor}, ${mixColor} ${adjustment}%)`;
}
